import axios from "axios";
import {
    getUrlForHolidayCalendars,
    getUrlForCalendarHolidays,
    getUrlForCalendarHolidaysPage,
    getUrlToCreateHoliday,
    getUrlToUpdateHoliday,
    getUrlToDeleteHoliday,
    getUrlForApplicableHolidays,
    getUrlForOptionalHolidays,
    getUrlForHolidayElection,
} from "utils/endpointUtils/holidayEndpointUtil";
import { setAuthHeader } from "app/services/auth.header.service";

export const loadHolidayCalendarsFromBackend = async () => {
    const config = setAuthHeader();
    if(config === null) throw new Error("Invalid Auth Header or Token Expired");

    const url = getUrlForHolidayCalendars();
    return await axios.get(url, config);
}

export const loadApplicableHolidaysFromBackend = async (fromDate, toDate) => {
    const config = setAuthHeader();
    if(config === null) throw new Error("Invalid Auth Header or Token Expired");

    const url = getUrlForApplicableHolidays(fromDate, toDate);
    return await axios.get(url, config);
}

export const loadCalendarHolidaysFromBackend = async (calendarId) => {
    const config = setAuthHeader();
    if(config === null) throw new Error("Invalid Auth Header or Token Expired");

    const url = getUrlForCalendarHolidays(calendarId);
    return await axios.get(url, config);
}

// Server-driven page fetch for the Master Data Holidays grid (scoped to one calendar).
// Returns the PageResponse envelope on response.data.
export const loadCalendarHolidaysPageFromBackend = async (calendarId, { page, pageSize, sortBy, sortDirection, searchQuery }) => {
    const config = setAuthHeader();
    if(config === null) throw new Error("Invalid Auth Header or Token Expired");

    const url = getUrlForCalendarHolidaysPage(calendarId, { page, pageSize, sortBy, sortDirection, searchQuery });
    return await axios.get(url, config);
}

export const addHolidayToBackend = async (calendarId, data) => {
    const config = setAuthHeader();
    if(config === null) throw new Error("Invalid Auth Header or Token Expired");

    const url = getUrlToCreateHoliday(calendarId);
    return await axios.post(url, data, config);
}

export const updateHolidayToBackend = async (calendarId, holidayId, data) => {
    const config = setAuthHeader();
    if(config === null) throw new Error("Invalid Auth Header or Token Expired");

    const url = getUrlToUpdateHoliday(calendarId, holidayId);
    return await axios.put(url, data, config);
}

export const deleteHolidayFromBackend = async (calendarId, holidayId) => {
    const config = setAuthHeader();
    if(config === null) throw new Error("Invalid Auth Header or Token Expired");

    const url = getUrlToDeleteHoliday(calendarId, holidayId);
    return await axios.delete(url, config);
}

export const loadOptionalHolidaysFromBackend = async (ownerId, isMember, year) => {
    const config = setAuthHeader();
    if(config === null) throw new Error("Invalid Auth Header or Token Expired");

    const url = getUrlForOptionalHolidays(ownerId, isMember, year);
    return await axios.get(url, config);
}

export const electHolidayInBackend = async (holidayId, ownerId, isMember) => {
    const config = setAuthHeader();
    if(config === null) throw new Error("Invalid Auth Header or Token Expired");

    const url = getUrlForHolidayElection(holidayId, ownerId, isMember);
    return await axios.post(url, null, config);
}

export const withdrawHolidayElectionInBackend = async (holidayId, ownerId, isMember) => {
    const config = setAuthHeader();
    if(config === null) throw new Error("Invalid Auth Header or Token Expired");

    const url = getUrlForHolidayElection(holidayId, ownerId, isMember);
    return await axios.delete(url, config);
}